const BASE = "http://103.79.74.237:8081/api/items";

export async function getItems() {
  const res = await fetch(BASE);
  if (!res.ok) throw new Error("Failed to load items");
  return res.json();
}
